import {Directive, HostListener} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[appPhoneMask]',
})
export class PhoneMaskDirective {
  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }

  onInputChange(event, backspace) {
    let newVal = event.replace(/\+38/g, '').replace(/\D/g, '');
    if (backspace && newVal.length <= 6) {
      newVal = newVal.substring(0, newVal.length - 1);
    }

    let prefix = '+38'

    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, `${prefix}($1)`);
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, `${prefix}($1) $2`);
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, `${prefix}($1) $2-$3`);
    } else {
      newVal = newVal.replace(/^38/, '');
      // Старий формат «8 067 123 45 67»: без цього обрізалась остання цифра і в замовлення
      // йшов чужий номер 8067123456 (бек перевіряє лише 10 цифр). Так само чистить бек в адмінці.
      newVal = newVal.replace(/^8(?=\d{10}$)/, '');
      newVal = newVal.substring(0, 10);
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, `${prefix}($1) $2-$3`);
    }
    this.ngControl.valueAccessor.writeValue(newVal);
  }
}
